/**
 * Shopify Bundle Google Ads virtual SKU tracking.
 * See Bundle虚拟sku.txt for generation rules and dataLayer event format.
 */
(function (window, document) {
  'use strict';

  var SESSION_KEY = '__bundleVirtualSku';
  var LOG_PREFIX = '[BundleVirtualSKU]';

  function ensureProductData() {
    var data = window.__productData;
    if (!data || typeof data !== 'object') {
      data = {};
      window.__productData = data;
    }
    if (!data.variants || typeof data.variants !== 'object') data.variants = {};
    if (!data.virtualSkus || typeof data.virtualSkus !== 'object') data.virtualSkus = {};
    if (!Array.isArray(data.giftVariantIds)) data.giftVariantIds = [];
    return data;
  }

  function normalizeVariantId(raw) {
    if (raw == null || raw === '') return '';
    var s = String(raw).trim();
    var m = s.match(/ProductVariant\/(\d+)/);
    return m ? m[1] : s;
  }

  function skuLast6(sku) {
    var s = String(sku || '');
    return s.slice(-6);
  }

  function centsToAmount(cents) {
    var n = Number(cents);
    if (!Number.isFinite(n)) return 0;
    return Number((n / 100).toFixed(2));
  }

  function registerVariant(variant, options) {
    if (!variant || variant.id == null) return;
    var data = ensureProductData();
    var id = String(variant.id);
    var sku = variant.sku != null ? String(variant.sku) : '';
    var existing = data.variants[id] || {};
    data.variants[id] = {
      sku: sku || existing.sku || '',
      price: variant.price != null ? variant.price : existing.price,
    };
    if (options && options.virtual && sku) {
      data.virtualSkus[sku] = true;
    }
    if (options && options.gift) {
      if (data.giftVariantIds.indexOf(id) === -1) data.giftVariantIds.push(id);
    }
  }

  function registerProductVariants(product, options) {
    if (!product || !Array.isArray(product.variants)) return;
    for (var i = 0; i < product.variants.length; i++) {
      registerVariant(product.variants[i], options);
    }
  }

  function collectProductDataFromDom() {
    var data = ensureProductData();

    document.querySelectorAll('[data-grid-product-json]').forEach(function (el) {
      try {
        registerProductVariants(JSON.parse(el.textContent || ''), { virtual: false });
      } catch (err) {
        console.warn(LOG_PREFIX, 'grid product json', err);
      }
    });

    document.querySelectorAll('[data-sub-product-info-json]').forEach(function (el) {
      try {
        var json = JSON.parse(el.textContent || '');
        registerProductVariants(json.product, {
          virtual: false,
          gift: !!json.is_gift,
        });
      } catch (err) {
        console.warn(LOG_PREFIX, 'sub product json', err);
      }
    });

    document.querySelectorAll('[data-main-products-bundle-json]').forEach(function (el) {
      try {
        var json = JSON.parse(el.textContent || '');
        var bundles = json.bundle_products || [];
        for (var i = 0; i < bundles.length; i++) {
          registerProductVariants(bundles[i] && bundles[i].info, { virtual: true });
        }
      } catch (err) {
        console.warn(LOG_PREFIX, 'bundle json', err);
      }
    });

    return data;
  }

  /** @returns {string[] | null} */
  function getVariantIdsFromURL() {
    var variantsParam;
    try {
      variantsParam = new URLSearchParams(window.location.search).get('variants');
    } catch (err) {
      return null;
    }
    if (variantsParam == null || String(variantsParam).trim() === '') return null;

    var ids = String(variantsParam)
      .split(',')
      .map(function (segment) {
        var s = String(segment || '').trim();
        if (!s) return '';
        var colon = s.indexOf(':');
        var rawId = colon === -1 ? s : s.slice(colon + 1);
        return normalizeVariantId(rawId);
      })
      .filter(Boolean);

    return ids.length ? ids : null;
  }

  /** @param {string} variantsParam */
  function isThemeBundle(variantsParam) {
    return typeof variantsParam === 'string' && variantsParam.indexOf(':') !== -1;
  }

  /** @param {string} variantId */
  function getSKUByVariantId(variantId) {
    var entry = ensureProductData().variants[String(variantId)];
    return entry && entry.sku ? String(entry.sku) : '';
  }

  /**
   * @param {string[]} variantIds
   * @param {boolean} isTheme
   */
  function generateVirtualSKU(variantIds, isTheme) {
    if (!Array.isArray(variantIds) || variantIds.length === 0) return '';

    var tails = [];
    for (var i = 0; i < variantIds.length; i++) {
      var sku = getSKUByVariantId(variantIds[i]);
      if (!sku) {
        console.warn(LOG_PREFIX, 'missing SKU for variant', variantIds[i]);
        return '';
      }
      tails.push(skuLast6(sku));
    }

    if (isTheme) {
      return 'BM' + tails.join('');
    }
    return 'BM' + tails[0] + tails.join('');
  }

  /** @param {string} virtualSKU */
  function isVirtualSKUExists(virtualSKU) {
    if (!virtualSKU) return false;
    var data = ensureProductData();
    return !!(data.virtualSkus && data.virtualSkus[virtualSKU]);
  }

  function getVariantsParam() {
    try {
      return new URLSearchParams(window.location.search).get('variants') || '';
    } catch (err) {
      return '';
    }
  }

  function filterGiftVariantIds(variantIds, variantsParam) {
    var gifts = {};
    var giftIds = ensureProductData().giftVariantIds || [];
    for (var i = 0; i < giftIds.length; i++) {
      gifts[String(giftIds[i])] = true;
    }

    var param = variantsParam || '';
    if (param.indexOf(':') !== -1) {
      var segments = param.split(',');
      for (var s = 0; s < segments.length; s++) {
        var idx = segments[s].indexOf(':');
        if (idx === -1) continue;
        var handle = segments[s].slice(0, idx).trim().toLowerCase();
        var id = normalizeVariantId(segments[s].slice(idx + 1));
        if (id && handle.indexOf('free-gift') === 0) {
          gifts[id] = true;
        }
      }
    }

    return (variantIds || []).filter(function (id) {
      return !gifts[String(id)];
    });
  }

  function persistSession(payload) {
    window.__bundleVirtualSKU = payload && payload.sku ? payload.sku : null;
    window.__bundleVirtualSkuMeta = payload || null;
    try {
      if (payload && payload.sku) {
        window.sessionStorage.setItem(SESSION_KEY, JSON.stringify(payload));
      } else {
        window.sessionStorage.removeItem(SESSION_KEY);
      }
    } catch (err) {
      /* private mode */
    }
  }

  function readSession() {
    if (window.__bundleVirtualSkuMeta && window.__bundleVirtualSkuMeta.sku) {
      return window.__bundleVirtualSkuMeta;
    }
    try {
      var raw = window.sessionStorage.getItem(SESSION_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (err) {
      return null;
    }
  }

  function persistCartAttributes(virtualSKU, bundleName, bundlePrice) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          _bundle_virtual_sku: virtualSKU || '',
          _bundle_virtual_name: bundleName || '',
          _bundle_virtual_price: bundlePrice != null ? String(bundlePrice) : '',
        },
      }),
    }).catch(function (err) {
      console.warn(LOG_PREFIX, 'cart attributes', err);
    });
  }

  function getCurrency() {
    return (
      ensureProductData().currency ||
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      'USD'
    );
  }

  function getBundleName(fallback) {
    return fallback || ensureProductData().bundleName || document.title || 'Bundle';
  }

  function logDataLayerPush(eventName, payload) {
    console.log(LOG_PREFIX, 'dataLayer.push ' + eventName, payload);
  }

  /**
   * @param {string} virtualSKU
   * @param {number} bundlePrice
   * @param {string} bundleName
   */
  function trackAddToCart(virtualSKU, bundlePrice, bundleName) {
    var payload = {
      event: 'add_to_cart',
      ecommerce: {
        items: [
          {
            item_id: virtualSKU,
            item_name: getBundleName(bundleName),
            price: bundlePrice,
            quantity: 1,
          },
        ],
      },
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(payload);
    logDataLayerPush('add_to_cart', payload);
  }

  /**
   * @param {string} orderId
   * @param {string} virtualSKU
   * @param {number} bundlePrice
   * @param {string} [currency]
   * @param {string} [bundleName]
   */
  function trackPurchase(orderId, virtualSKU, bundlePrice, currency, bundleName) {
    var payload = {
      event: 'purchase',
      ecommerce: {
        transaction_id: orderId,
        value: bundlePrice,
        currency: currency || getCurrency(),
        items: [
          {
            item_id: virtualSKU,
            item_name: getBundleName(bundleName),
            price: bundlePrice,
            quantity: 1,
          },
        ],
      },
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(payload);
    logDataLayerPush('purchase', payload);
  }

  /**
   * @param {string[]} variantIds
   * @param {boolean} isTheme
   * @returns {string | null}
   */
  function resolveVirtualSKU(variantIds, isTheme) {
    collectProductDataFromDom();
    var ids = filterGiftVariantIds(variantIds, getVariantsParam());
    if (!ids.length) {
      persistSession(null);
      return null;
    }

    var virtualSKU = generateVirtualSKU(ids, !!isTheme);
    if (!virtualSKU) return null;

    if (!isVirtualSKUExists(virtualSKU)) {
      console.warn(LOG_PREFIX, 'skip tracking, SKU not in Shopify:', virtualSKU);
      persistSession(null);
      return null;
    }

    persistSession({
      sku: virtualSKU,
      isTheme: !!isTheme,
      variantIds: ids,
      currency: getCurrency(),
      bundleName: getBundleName(),
    });
    return virtualSKU;
  }

  function handleBundleTracking() {
    collectProductDataFromDom();
    var variantIds = getVariantIdsFromURL();
    if (!variantIds) {
      persistSession(null);
      return null;
    }
    var isTheme = isThemeBundle(getVariantsParam());
    if (ensureProductData().bundleType === 'theme') isTheme = true;
    if (ensureProductData().bundleType === 'diy') isTheme = false;
    return resolveVirtualSKU(variantIds, isTheme);
  }

  /**
   * @param {{ variantIds: string[], isTheme: boolean, bundlePriceCents?: number, bundlePrice?: number, bundleName?: string, persistAttributes?: boolean }} opts
   */
  function trackAddToCartIfValid(opts) {
    opts = opts || {};
    var ids = (opts.variantIds || []).map(normalizeVariantId).filter(Boolean);
    if (!ids.length) return null;

    var virtualSKU = resolveVirtualSKU(ids, opts.isTheme);
    if (!virtualSKU) return null;

    var price =
      opts.bundlePrice != null
        ? Number(opts.bundlePrice)
        : centsToAmount(opts.bundlePriceCents);
    var name = getBundleName(opts.bundleName);

    persistSession({
      sku: virtualSKU,
      isTheme: !!opts.isTheme,
      variantIds: ids,
      price: price,
      currency: getCurrency(),
      bundleName: name,
    });

    trackAddToCart(virtualSKU, price, name);

    if (opts.persistAttributes !== false) {
      persistCartAttributes(virtualSKU, name, price);
    }
    return virtualSKU;
  }

  function trackPurchaseFromCheckout() {
    var checkout = window.Shopify && window.Shopify.checkout;
    var stored = readSession();
    if (!checkout || !stored || !stored.sku) return null;
    if (!isVirtualSKUExists(stored.sku)) {
      console.warn(LOG_PREFIX, 'skip purchase, SKU not in Shopify:', stored.sku);
      return null;
    }
    trackPurchase(
      String(checkout.order_id || checkout.order_name || ''),
      stored.sku,
      stored.price != null ? stored.price : Number(checkout.total_price),
      checkout.currency || stored.currency || getCurrency(),
      stored.bundleName
    );
    return stored.sku;
  }

  var api = {
    getVariantIdsFromURL: getVariantIdsFromURL,
    isThemeBundle: isThemeBundle,
    getSKUByVariantId: getSKUByVariantId,
    generateVirtualSKU: generateVirtualSKU,
    isVirtualSKUExists: isVirtualSKUExists,
    trackAddToCart: trackAddToCart,
    trackPurchase: trackPurchase,
    handleBundleTracking: handleBundleTracking,
    resolveVirtualSKU: resolveVirtualSKU,
    trackAddToCartIfValid: trackAddToCartIfValid,
    trackPurchaseFromCheckout: trackPurchaseFromCheckout,
    collectProductDataFromDom: collectProductDataFromDom,
  };

  window.BundleVirtualSkuTracking = api;
  window.getVariantIdsFromURL = getVariantIdsFromURL;
  window.isThemeBundle = isThemeBundle;
  window.getSKUByVariantId = getSKUByVariantId;
  window.generateVirtualSKU = generateVirtualSKU;
  window.isVirtualSKUExists = isVirtualSKUExists;
  window.trackAddToCart = window.trackAddToCart || trackAddToCart;
  window.trackPurchase = window.trackPurchase || trackPurchase;
  window.handleBundleTracking = handleBundleTracking;

  function init() {
    collectProductDataFromDom();
    handleBundleTracking();
    if (window.Shopify && window.Shopify.checkout) {
      trackPurchaseFromCheckout();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(window, document);
